/* Thin wrapper so screens never import the Telegram SDK directly.
 * Every call is a safe no-op outside Telegram (plain-browser dev). */
import { hapticFeedback } from '@telegram-apps/sdk-react';

/** Money settled / action confirmed — the big one. */
export function hapticSuccess() {
  try {
    if (hapticFeedback.notificationOccurred.isAvailable()) hapticFeedback.notificationOccurred('success');
  } catch {
    /* not in Telegram */
  }
}

/** Light tick for selection / navigation. */
export function hapticTick() {
  try {
    if (hapticFeedback.selectionChanged.isAvailable()) hapticFeedback.selectionChanged();
  } catch {
    /* not in Telegram */
  }
}
